// import useWindowSize from 'hooks/use-windowSize';

import LectureDesktop from './type/LectureDesktop';
// import LectureMobile from './type/LectureMobile';

const Lecture = () => {
	// const { desktopDevice } = useWindowSize();

	// return <>{desktopDevice ? <LectureDesktop /> : <LectureMobile />}</>;
	return <LectureDesktop />;
};

export default Lecture;
